<div class="summary theme-new-green">
    <div id="page-header" class="banner-area-1">
        <h1 class="bh-sl-title">My Message Board</h1>
    </div>
    <div class="row">
        <p-table [value]="messages" [responsive]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" style="width:20%">Searcher Name</th>
                    <th scope="col" style="width:20%">Searcher Email</th>
                    <th scope="col">Message</th>
                    <th scope="col" style="width:20%">Received On</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-msg>
                <tr>
                    <td>{{ msg.searcher_name }}</td>
                    <td>{{ msg.searcher_email }}</td>
                    <td class="message-text">
                        <button type="button" class="btn-link" (click)="viewCommunication(msg)">
                            {{ msg.searcher_message }}
                        </button>
                    </td>
                    <td>{{ msg.message_received_on | date:'medium' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4">No messages found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>